import { Enums } from "../common/enums";
import commonConstants from "../common/constants";
import clientConstants from "./constants";

import Assets from "./assets";
import Bazaar from "./bazaar";
import Games from "./games";
import I18n from "./i18n";
import ImportTool from "./importer";
import Search, { Sort } from "./search";
import UI from "./ui";
import Utils from "./utils";
import initNotificationDrawer from "./notification-drawer";
import ValidateUtils from "./validate-utils";

import loadComponents from "./.build/components";
import loadPartials from "./.build/partials";
import loadTemplates from "./.build/templates";

export default class TheForge {
    static async init() {
        /* Enable Tooltips and Popover */
        $('[data-toggle="tooltip"]').tooltip();
        $('[data-toggle="popover"]').popover();
        $('[data-toggle="dropdown"]').dropdown();

        /* Hook file uploads */
        Assets.hookUploadForms();
        await UI.initI18n();
        UI.initHandlebars();
        UI.renderVueApps();
        UI.initHooks();
        this.maximizeMainHeight();
        this.lazyLoadYoutube();
        this.initDecorations();
        this.initMinigame();
        this.initThemeToggler();
        this.initLangSelector();
        Utils.timeoutFlashMessages();
        UI.renderPushedAlerts();
        initNotificationDrawer();
        // Add the callback to be used by turnstile
        window.onloadTurnstileCallback = UI.initTurnstile;

        /* Hook copy-to-clipboard */
        this.popover_show_timeout = 0;
        this.popover_hide_timeout = 0;

        $(".dismiss-forge-service-announcement").on("click", (ev) => {
            const id = ev.currentTarget.dataset.serviceAnnouncement;
            Utils.api("service-announcement", { id }).catch(() => null);
        });

        /* Page specific hooks */
        switch (window.location.pathname) {
            case "/account": {
                const form_profile = $(".form-profile");
                const avatar_upload = form_profile.find("input[name=avatar-upload]")[0];
                const uploadAvatar = async (input) => {
                    const urls = await Assets.uploadInput(input);
                    if (urls[0]) {
                        $("#profile-avatar-image")[0].src = urls[0];
                    }
                };
                form_profile
                    .find(".upload-button")
                    .off("click")
                    .on("click", () => uploadAvatar(avatar_upload));
                break;
            }
            case "/": {
                /* The parallax speed matches the end of the animation according to how much of the image we want out of sight (ratio: 1 / parallaxSpeed)
                 * ie. {parallaxSpeed: 3} the image will be fully bottom-aligned when 33% of its height has been scrolled past */
                const navigationBar = $("nav.main-navigation"); // Navbar ref
                const parallaxTargets = $(".banner-image"); // Parallax images
                for (const elem of parallaxTargets) {
                    // Init settings
                    elem.parallaxSpeed = 4;
                    elem.lastOffset = -1;

                    // Store element horizontal offset, default to center
                    try {
                        const computed = window.getComputedStyle(elem);
                        elem.xPos = computed.objectPosition.match(/^\s*(.*?)%/)[1];
                    } catch {
                        elem.xPos = "50";
                    }
                }
                // Only hook if we have elements to alter
                if (parallaxTargets.length > 0) {
                    // Wheel hook and passive mode avoids resource hogging, but we can use neither since we have the parallax front and center in the frontpage
                    document.addEventListener("scroll", this.parallax.bind(this, parallaxTargets, navigationBar), {
                        capture: false,
                        passive: true,
                    });
                }
                break;
            }
            default:
                break;
        }
    }

    static initNavigationBar() {
        const menus = document.querySelectorAll(".menu");
        const menuNav = document.querySelector(".menu.nav");
        document.documentElement.addEventListener("click", () => {
            menus.forEach((m) => m.classList.remove("active"));
        });

        document.querySelector(".nav-button").addEventListener("click", (event) => {
            menuNav.classList.toggle("active");
            event.stopPropagation();
        });
        const menuTypes = ["nav", "top", "sub"];
        menus.forEach((el) =>
            el.addEventListener("click", (event) => {
                let menuType = null;
                for (const type of menuTypes) {
                    if (event.target.parentElement.classList.contains(type)) {
                        menuType = type;
                        break;
                    }
                }
                if (menuType) {
                    menus.forEach((m) => {
                        if (m.classList.contains(menuType)) {
                            m.classList.remove("active");
                        }
                    });
                }
                if (
                    event.target.classList.contains("menu-toggle") ||
                    (event.target.classList.contains("menu-label") && event.target.href === "")
                ) {
                    event.target.parentElement.classList.toggle("active");
                }
                if (event.target.closest(".menu").classList.contains("menu-help-icon")) {
                    // Open Kapa.ai help interface
                    window.Kapa.open();
                }
                event.stopPropagation();
            })
        );

        // Shrink profile name if necessary;
        const profileName = menuNav.querySelector(".user-profile-menu .user-profile-name");
        if (profileName) {
            this.fitText(profileName);
        }
    }

    static lazyLoadYoutube() {
        $(".youtube-lazyload").click((ev) => {
            const iframe = document.createElement("iframe");

            iframe.setAttribute("frameborder", "0");
            iframe.setAttribute("allowfullscreen", "");
            iframe.setAttribute("allow", "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture");
            iframe.setAttribute(
                "src",
                "https://www.youtube.com/embed/" + ev.currentTarget.dataset.embed + "?rel=0&showinfo=0&autoplay=1"
            );
            ev.currentTarget.innerHTML = "";
            ev.currentTarget.appendChild(iframe);
        });
    }

    static initMinigame() {
        const minigamesIcon = $("#minigames-icon");
        if (window.location.pathname === "/solitaire" || window.location.pathname === "/dungeon-solitaire") {
            minigamesIcon.addClass("active");
        } else {
            minigamesIcon.removeClass("active");
        }
    }

    static initDecorations() {
        const theme = $("#decorations-btn");
        const themeIcon = $("#decorations-icon");
        if (theme.length === 0 || themeIcon.length === 0) {
            return;
        }

        const showDecorations = JSON.parse(localStorage.getItem("decorations"));
        if (showDecorations) {
            themeIcon.addClass("active");
            $(".top-decorations").addClass("show");
            $(".bottom-decorations").addClass("show");
        }

        theme.on("click", (ev) => {
            themeIcon.toggleClass("active");
            ev.preventDefault();
            ev.stopPropagation();

            // toggle decorations
            $(".top-decorations").toggleClass("show");
            $(".bottom-decorations").toggleClass("show");

            localStorage.setItem("decorations", !JSON.parse(localStorage.getItem("decorations")));
        });

        // spider clicks
        const spiders = $('[class*="spider_"]');
        spiders.on("click", (ev) => {
            ev.target.classList.toggle("remove-spider");
        });

        //snowflake mouseover
        const snowflakes = $(".snowflake");
        snowflakes.on("mouseover", (ev) => {
            if (ev.target.classList.contains("remove-snowflake")) {
                return;
            }
            ev.target.classList.toggle("remove-snowflake");
            window.setTimeout(() => {
                ev.target.classList.toggle("remove-snowflake");
            }, 3000);
        });
    }

    static initThemeToggler() {
        const toggle = $(".forge-theme-toggle");
        if (toggle.length === 0) {
            return;
        }

        const themeLink = $("link[rel=stylesheet]")
            .toArray()
            .find((l) => l.attributes.href && l.attributes.href.value.startsWith("/css/themes/"));
        if (!themeLink) {
            return toggle.remove();
        }
        const DARK_THEMES = ["slate", "darkly", "superhero", "solar", "cyborg"];
        const currentTheme = themeLink.href.match(/([^/]+)\.css/)[1];
        const checkbox = toggle.find("input");
        checkbox[0].checked = DARK_THEMES.includes(currentTheme);
        toggle.click((ev) => {
            this.toggleTheme(checkbox[0], themeLink);
            ev.preventDefault();
            ev.stopPropagation();
        });
        toggle.find("input").on("change", () => {
            this.toggleTheme(checkbox[0], themeLink);
        });
    }

    static toggleTheme(checkbox, link) {
        checkbox.checked = !checkbox.checked;
        const theme = checkbox.checked ? "slate" : "default";
        link.attributes.href.value = `/css/themes/${theme}.css`;
        document.querySelector("body").classList.value = `theme theme--${theme}`;
        if (this.setThemeTimeout) {
            clearTimeout(this.setThemeTimeout);
        }
        this.setThemeTimeout = setTimeout(() => Utils.api("profile", { theme }), 3000);
    }

    static initLangSelector() {
        const selector = document.querySelector(".forge-lang-select");
        if (!selector) {
            return;
        }

        const dropdownItems = selector.querySelectorAll(".dropdown-item");
        dropdownItems.forEach((item) => {
            item.addEventListener("click", async () => {
                const lang = item.getAttribute("data-lang");
                await this.onSelectLang(lang);
            });
        });
    }

    static async onSelectLang(lang) {
        const response = await Utils.api("i18n/update-language", { lang });
        if (response.success) {
            window.location.reload();
        } else {
            UI.alert(
                "danger",
                t(`Error updating user language: {{- error}}`, {
                    error: response.error || t("Unknown Error"),
                })
            );
        }
    }

    static copyInputToClipboard(input) {
        Utils.copyToClipboard(input.value);
        if (input.dataset.toggle !== "popover") {
            return;
        }
        $(input).popover("hide");
        clearTimeout(this.popover_show_timeout);
        clearTimeout(this.popover_hide_timeout);
        this.popover_show_timeout = setTimeout(() => $(input).popover("show"), 300);
        this.popover_hide_timeout = setTimeout(() => $(input).popover("hide"), 3000);
    }

    static parallax(targets, navbar) {
        for (const elem of targets) {
            const rect = elem.getBoundingClientRect();
            const offset = rect.height + rect.top - navbar.height();

            /* Only update if partially visible or not fully scrolled
             * If the picture is out of the viewport, make sure it's either top or bottom aligned for when it gets back in view */
            if ((0 < offset && offset < rect.height) || (elem.lastOffset != 0 && elem.lastOffset != 1)) {
                // Clamp the result to 0-100%
                const newOffset = Math.min(Math.max((1 - offset / rect.height) * elem.parallaxSpeed, 0), 1);

                // Only update if needed
                if (elem.lastOffset != newOffset) {
                    elem.lastOffset = newOffset;
                    const positionY = elem.lastOffset * 100;
                    elem.style.objectPosition = `${elem.xPos}% ${positionY}%`;
                }
            }
        }
    }

    /**
     * Resizes text from `1em` to `minEmHeight` until it fits the available
     * space. It also hooks the `resize` event, so that text is automatically
     * resized based on the new available space.
     * @param {*} el HTML element
     * @param {number} minEmHeight Minimum size in em
     */
    static fitText(el, minEmHeight = 0.7) {
        const isOverflowing = () => el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;
        const setFontSize = (size) => (el.style.fontSize = `${size}em`);
        const resizeElementText = () => {
            let fs = 1;
            setFontSize(fs);
            // Using `minEmHeight + .1` to hackishly check `> minEmHeight`,
            // for rounding errors shenanigans.
            while (isOverflowing() && fs >= minEmHeight + 0.1) {
                fs -= 0.1;
                setFontSize(fs);
            }
        };
        window.addEventListener("resize", resizeElementText);
        setTimeout(resizeElementText, 100);
    }

    /**
     * Extend the main height to keep the footer at the bottom of the page.
     */
    static maximizeMainHeight() {
        const main = document.getElementsByTagName("main")[0];
        const footer = document.getElementById("main-footer");
        const computedPx = (e, prop) => parseInt(window.getComputedStyle(e)[prop]);
        const hook = () => {
            const mainHeight =
                UI.getScreenSize().height -
                main.offsetTop -
                computedPx(main.parentElement, "paddingLeft") - // Responsive spacing
                computedPx(footer, "height") -
                1; // 1px buffer for rounding errors to avoid scrollbars
            main.style.minHeight = `${mainHeight}px`;
        };
        window.addEventListener("resize", hook);
        hook();
    }
}

Object.assign(window, {
    TheForge,
    // Client Globals
    Assets,
    Bazaar,
    Games,
    I18n,
    ImportTool,
    Search,
    Sort,
    UI,
    Utils,
    ValidateUtils,
    // Common Globals
    Enums,
    // Constants
    ...commonConstants,
    ...clientConstants,
});

window.addEventListener("DOMContentLoaded", async () => {
    await TheForge.init();
    loadComponents();
    loadPartials();
    loadTemplates();
    TheForge.initNavigationBar();
});
